import { AbstractControl, ValidationErrors } from '@angular/forms';
import * as IBAN from 'iban';

export class IBANService {
  static validateIban(c: AbstractControl): ValidationErrors {
    if (c.value) {
      const trimmed = c.value.toString().replace(/\s/g, '');
      if (!/^[A-Z0-9]+$/i.test(trimmed)) {
        return { iban: { value: c.value } };
      }
      if (!IBAN.isValid(c.value)) {
        return { iban: { value: c.value } };
      }
    }

    return null as any;
  }

  static isValidIban(value: string): boolean {
    if (!value) return false;
    const trimmed = value.replace(/\s/g, '');
    return /^[A-Z0-9]+$/i.test(trimmed) && IBAN.isValid(value);
  }

  static isValidBic(value: string): boolean {
    if (!value) return false;
    const bicValue = value.toUpperCase().trim();
    return /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(bicValue);
  }

  static validateBic(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;
    if (!IBANService.isValidBic(control.value.toString())) {
      return { bic: { value: control.value } };
    }
    return null;
  }
}
